import { useObservations } from 'pages/pointClouds/components/observations/hooks/useObservations'
import React from 'react'

import { ObservationMarker } from './ObservationMarker'

export const ObservationMarkers: React.FC = () => {
  const { observations } = useObservations()

  return (
    <>
      {observations.map((observation) => (
        <ObservationMarker key={observation.id} observation={observation} />
      ))}
    </>
  )
}
